export default "/static/4876f1c1aab90815.svg"